import React from "react";

export const RollbarTestError = () => {
    let test = null;
    console.log(test[0])
    return <div>oups</div>
}